import { render, staticRenderFns } from "./StudiesView.vue?vue&type=template&id=1676d4c3&scoped=true&"
import script from "./StudiesView.vue?vue&type=script&lang=js&"
export * from "./StudiesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1676d4c3",
  null
  
)

export default component.exports